import accessAuth from "./AuthControl"
import accessDashboard from "./DashboardControl"
import accessMaster from "./MasterControl"
import accessUsers from "./UsersControl"
import accessSettings from "./SettingsControl"
import accessNotifications from "./NotificationsControl"
import accessProductManagement from "./ProductManagementControl"
import accessInventory from "./InventoryControl"
import accessSales from "./SalesControl"

const RoutesMap = {
    ...accessAuth,
    ...accessDashboard,
    ...accessMaster,
    ...accessSettings,
    ...accessUsers,
    ...accessNotifications,
    ...accessProductManagement,
    ...accessInventory,
    ...accessSales,
}

export default RoutesMap;